import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Inject, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

// Modelos
import { CanalEntrada } from '../../models/canal-entrada.model';
// Servicios
import { CanalEntradaService } from '../../services/canal-entrada.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { CanalEntradaEditComponent } from '../canal-entrada-edit/canal-entrada-edit.component';
import { CellHyperlinkCustomComponent } from '../cell-hyperlink-custom/cell-hyperlink-custom.component';
import { TranslateService } from '@ngx-translate/core';
import { YesNoPipe } from '../../pipes/yesNo.pipe';


@Component({
  selector: 'app-canal-entrada',
  templateUrl: './canal-entrada.component.html',
  styleUrls: ['./canal-entrada.component.scss']
})
export class CanalEntradaComponent implements OnInit {

  public displayedColumns: any[];
  public rowData: any[];
  public CanalEntradaTable: MatTableDataSource<CanalEntrada>;
  public translate: TranslateService;

  // Campos de filtrado
  defaultPageIndex;
  defaultPageSize;
  public defaultSortColumn;
  public defaultSortOrder;
  defaultFilterColumn;
  filterQuery: string;
  pageEvent: PageEvent;

  searchTerm: FormControl = new FormControl();


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  createColumnDef() {
    const displayedColumns = [
      {
        headerName: "Eliminar", field: 'id', suppressFilter: true, suppressSorting: true,
        template:
          `
            <a data-action-type="remove">Borrar</a>`,
        pinned: 'left',
        width: 90
      },
      // {
      //   headerName: 'Editar', field: 'id',
      //   template: `<a data-action-type="edit">Editar</a>`,
      //   width: 55
      // },
      {
        headerName: 'Editar', field: 'id', suppressFilter: true, suppressSorting: true,
        cellRendererFramework: CellHyperlinkCustomComponent,
        cellRendererParams: { destUrl: "/canalEntrada/", hyperlinkText: "Editar" },
        pinned: 'left',
        width: 90,
        minWidth: 90
      },
      { field: 'descripcion', suppressFilter: true, suppressSorting: true, },
      {  headerName: 'Incompatibilidad Contrato', field: 'filtroEntidad', suppressFilter: true, suppressSorting: true, },
      { headerName: this._translateService.instant('administracion.ag_status'), field: 'activo', minWidth: 15, valueFormatter: (data) => this._booleanTransform.transform(data.value) },
    ];

    return displayedColumns;
  }

  dialogConfig: MatDialogConfig;
  constructor(private canalEntradaService: CanalEntradaService, private router: Router, private _dialog: MatDialog, public _translateService: TranslateService,
    private _booleanTransform: YesNoPipe) {
    console.log("constructor");

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;
    this.displayedColumns = this.createColumnDef();
    this.defaultPageIndex = 0;
    this.defaultPageSize = 10;
    this.defaultSortColumn = 'ID';
    this.defaultSortOrder = 'desc';
    this.defaultFilterColumn = 'allFields';
    this.filterQuery = null;
  }

  public defaultColDef = {
    width: 100,
    filter: 'agTextColumnFilter'
  };

  ngOnInit() {
    console.log("ngOnInit");
    //Cuando hace submit llamamos a lo que esta dentro
    this.searchTerm.valueChanges.pipe(debounceTime(400)).subscribe(data => {

      this.loadData(data);
    });
    this.loadData();
  }

  loadData(query: string = null) {
    console.log("loadData");


    // if (this.searchTerm.value != null) {
    //   query = this.searchTerm.value;
    // } else {
    //   query = this.searchTerm.value;
    // }


    this.pageEvent = new PageEvent();
    this.pageEvent.pageIndex = this.defaultPageIndex;
    this.pageEvent.pageSize = this.defaultPageSize;
    if (query)
      this.filterQuery = query;
    else
      this.filterQuery = null;
    console.log("buscando por: " + query);
    console.log("buscando por: " + this.filterQuery);
    this.getData(this.pageEvent);
  }

  getData(event: PageEvent): PageEvent {
    console.log("getData");
    let sortColumn;
    let sortOrder;
    let filterColumn;
    let filterQuery;

    sortColumn = (this.sort) ? this.sort.active : this.defaultSortColumn;
    sortOrder = (this.sort) ? this.sort.direction : this.defaultSortOrder;
    filterColumn = (this.filterQuery) ? this.defaultFilterColumn : null;
    filterQuery = (this.filterQuery) ? this.filterQuery : null;
    this.canalEntradaService.getData(
      event.pageIndex,
      event.pageSize,
      sortColumn,
      sortOrder,
      filterColumn,
      filterQuery)
      .subscribe(result => {
        console.log("totalCount: " + result.totalCount);
        console.log(this.paginator);
        this.paginator.length = result.totalCount;
        this.paginator.pageIndex = result.pageIndex;
        this.paginator.pageSize = result.pageSize;
        console.log(result);
        this.rowData = result.data;
        //this.CanalEntradaTable = new MatTableDataSource<CanalEntrada>(result.data);
      }, error => console.error(error));
    return event;
  }

  clickRow(event) {
    this.router.navigate([`/canalEntrada/${event.data.id}`]);
  }

  public onCellClickedEvent($event) {

    if ($event.event.target !== undefined) {
      let data = $event.data;
      let actionType = $event.event.target.getAttribute("data-action-type");


      switch (actionType) {
        case "remove":
          return this.onActionRemoveClick(data);
      }
    }
  }

  onActionRemoveClick(data: any) {

    var ans = confirm("Quieres eliminar el registro con Id: " + data.id);
    if (ans) {
      this.canalEntradaService.delete(data.id).subscribe((data: any) => {
        if (data.estado == "Error") {
          alert("Este canal de entrada está asociado a alguna tasación, por lo que no se puede borrar. Si lo desea puede marcarlo como inactivo.");
        }
      });
      this.loadData();
    }
  }
}
